const rankingData = [
  { rank: 1, title: '长安十二时辰 第二季', tag: '热播中', type: '剧集', hot: true, change: 'new' },
  { rank: 2, title: '星际迷航：新纪元', tag: '4K', type: '电影', hot: true, change: 'up' },
  { rank: 3, title: '无声追踪', tag: '新上线', type: '电影', hot: true, change: 'new' },
  { rank: 4, title: '暗夜行者 最终季', tag: '完结', type: '剧集', hot: false, change: 'down' },
  { rank: 5, title: '时空旅人', tag: '热映', type: '电影', hot: true, change: 'up' },
  { rank: 6, title: '宫崎骏动画合集', tag: '经典', type: '动漫', hot: false, change: 'same' },
  { rank: 7, title: '极限挑战 第十季', tag: '更新中', type: '综艺', hot: false, change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            热播榜单
          </h2>
          <span className="text-foreground-400 text-sm ml-auto">
            <i className="ri-timer-flash-line mr-1"></i>实时更新
          </span>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              {/* Rank */}
              <span className={`w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center text-xs md:text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500/70 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-500/40 text-accent-900'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </span>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-800 text-sm md:text-base font-medium truncate">
                  {item.title}
                </h3>
                <span className="text-foreground-500 text-xs">{item.type}</span>
              </div>

              {/* Tag */}
              {item.tag && (
                <span className={`hidden sm:inline-flex text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                  item.hot
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.tag}
                </span>
              )}

              {/* Change */}
              <span className="flex-shrink-0 w-5 text-center">
                {item.change === 'up' && <i className="ri-arrow-up-fill text-accent-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-fill text-foreground-400 text-sm"></i>}
                {item.change === 'new' && <span className="text-primary-500 text-xs font-bold">NEW</span>}
                {item.change === 'same' && <span className="text-foreground-400 text-xs">—</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}